import React, { useEffect, useState, useRef } from 'react';
import {
    DialogTitle, DialogContent, DialogActions, Dialog, makeStyles, Paper, ClickAwayListener, MenuList, MenuItem, Card, CardContent,
    Divider,
    Popper,
    Grow
} from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { getTripStartDateFilterValues, getRequestTimeInMillis, getEpochForSpecificMonth,listMonthsBetweenDate } from "../../../utils/utils";
import { Box } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { SelectionDropDown } from '../../../components/icons';
// import {
//     TRIP_FILTER_STATUS,
//     TRIP_FILTER_STATUS_MAPPING,
// } from "../../../store/constants";

const useStyles = makeStyles((theme) => ({

    filterButton: {
        backgroundColor: "#fff",
        // margin: "0 3px",
        borderRadius: 30,
        textTransform: "capitalize",
        padding: "5px 10px"
    },
    menu: {
        position: "absolute",
        zIndex: 10000,
        top: "14%",
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        [theme.breakpoints.up("lg")]: {
            maxWidth: 470,
        },
        [theme.breakpoints.up("xl")]: {
            maxWidth: 470,
        }
    },
    divV1: {
        height: 218,
        overflow: 'auto',
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10
    },
    cardContentV1: {
        padding: 0
    },
    cardV1: {
        width: '10em'
    },
    arrowDropDownIconV1: {
        marginTop: -3
    },
    selectionIcon: {
    },
    menuItemV1: {
        display: 'flex', justifyContent: 'center', fontWeight: 300, paddingTop: 10, paddingBottom: 10
    },
    paper1: {
        maxHeight: '19em',
        overflow: 'auto'
    },
    wV1: {
        width: '100%'
    },
    filterButtonTrip: {
        backgroundColor: 'white', textTransform: 'capitalize'
    },
    filterButtonExpenses: {
        textTransform: 'capitalize',
        color:'#03c',
        padding:0,
        minWidth:'unset',
        marginLeft:12
    },
    selected:{
        fontSize:20,
        fontWeight:600,
        color:'#03c'
    }
}));

const FilterComponent = ({ reportType,value, user, defaultValue, vehicle, pnlDate, fromMonthlyBalance, monthlyDateValue, monthlyDate, fromPartyIncomeReport }) => {

    const [open, setOpen] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(defaultValue ? defaultValue : "");
    const [selectedPDFFilterDate, setSelectedPDFFilterDate] = useState("YEAR");
    const anchorRef = React.useRef(null);
    const prevOpen = React.useRef(open);

    const classes = useStyles();
    const MONTHS = listMonthsBetweenDate("2019-12-01")?listMonthsBetweenDate("2019-12-01").reverse():[];
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, []);
    useEffect(() => {
        setSelectedMonth(formatDateTruckIncome(value))
    }, [value]);

    useEffect(() => {
 if (reportType == "Monthly Balance Tab") {
            let monthlyDate = monthlyDateValue.split(" ");
            let month = monthlyDate[0].slice(0, 3);
            let dateValue = monthlyDate[1];
            let joinedDate = month + "-" + dateValue;
            setSelectedMonth(joinedDate);
        } else if (reportType == "Trip Book") {
            let monthlyDate = monthlyDateValue.split(" ");
            let month = monthlyDate[0].slice(0, 3);
            let dateValue = monthlyDate[1];
            let joinedDate = month + " " + dateValue;
            setSelectedMonth(joinedDate);
        } else if (reportType == "Trip Profit & Loss Report") {
            setSelectedMonth(vehicle.tripPNLMonths && vehicle.tripPNLMonths.months ? vehicle.tripPNLMonths.months[0] : "")
        } else if (reportType == "Truck Income Report" || reportType == "Profit Loss Report") {
            if (defaultValue) {
                setSelectedMonth(formatDateTruckIncome(defaultValue));
            } else {
                setSelectedMonth(formatDateTruckIncome(user.pnlMonths ? user.pnlMonths[0] : ""));
            }
        }else if (reportType == "expenses") {
            if (defaultValue && !MONTHS) {
                setSelectedMonth(formatDateTruckIncome(defaultValue));
            } else {
                setSelectedMonth(MONTHS &&  MONTHS[0] &&  MONTHS[0].display ? MONTHS[0].display : "");
            }
        } else if (reportType == "Truck Monthly Profit and Loss Report") {
            if (defaultValue) {
                setSelectedMonth(formatDateTruckIncome(defaultValue));
            } else {
                setSelectedMonth(formatDateTruckIncome(user.pnlMonths ? user.pnlMonths[0] : ""));
            }
        } else if (reportType == "Party Income Report") {
            if (defaultValue) {
                setSelectedMonth(formatDateTruckIncome(defaultValue));
            } else {
                setSelectedMonth(formatDateTruckIncome(user.pnlMonths ? user.pnlMonths[0] : ""));
            }
        } else if (reportType == "Profit and Loss Report") {
            setSelectedMonth(formatDateTruckIncome(defaultValue));
        } else if (fromPartyIncomeReport) {
            if (defaultValue) {
                setSelectedMonth(formatDateTruckIncome(defaultValue));
            } else {
                setSelectedMonth(formatDateTruckIncome(user.pnlMonths ? user.pnlMonths[0] : ""));
            }
        }
    }, [user.pnlMonths, vehicle.tripPNLMonths]);

    // useEffect(() => {
    //     let monthlyDate = monthlyDateValue

    // }, [monthlyDateValue]);

    const handleDateFilterClickOpen = (checkFilterType) => {
        setOpen(true);
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    }

    const handleItemClick = (dateValue) => {
        setOpen(false);
        if (reportType == "Trip Profit & Loss Report" || reportType == "Truck Monthly Profit & Loss") {
            pnlDate(dateValue);
            setSelectedMonth(dateValue);
        } else if (reportType == "Monthly Balance Tab") {
            setSelectedMonth(dateValue);
            monthlyDate(dateValue);
        } else if (reportType == "Trip Book") {
            var splitted = dateValue.split("-");
            setSelectedMonth(splitted.join(" "));
            monthlyDate(dateValue);
        } else if (reportType == "Truck Income Report" || reportType == "Truck Monthly Profit and Loss Report" || reportType == "Profit Loss Report" || reportType == "Profit and Loss Report") {
            pnlDate(dateValue);
            setSelectedMonth(formatDateTruckIncome(dateValue));
        }else if (reportType === "expenses") {
            pnlDate(dateValue.value);
            setSelectedMonth(formatDateTruckIncome(dateValue.value));
        } else if (reportType == "Party Income Report") {
            pnlDate(dateValue);
            setSelectedMonth(formatDateTruckIncome(dateValue));
        } else if (fromPartyIncomeReport) {
            const formatedDate = formatDateTruckIncome(dateValue);
            pnlDate(getEpochForSpecificMonth(formatedDate));
            setSelectedMonth(formatedDate);
        }
    }

    const formatDateTruckIncome = (date) => {
        if(!date)
            return ''
        let dateArray;

        if (date && date.includes("-")) {
            dateArray = date.split("-");
        } else {
            dateArray = date.split(" ");
        }

        let month = dateArray && dateArray[0] ? dateArray[0] : ""

        switch (month.toLowerCase()) {
            case 'jan': month = "January"; break;
            case 'feb': month = "February"; break;
            case 'mar': month = "March"; break;
            case 'apr': month = "April"; break;
            case 'may': month = "May"; break;
            case 'jun': month = "June"; break;
            case 'jul': month = "July"; break;
            case 'aug': month = "August"; break;
            case 'sep': month = "September"; break;
            case 'oct': month = "October"; break;
            case 'nov': month = "November"; break;
            case 'dec': month = "December"; break;
        }

        let finalDate = month + " " + dateArray[1];

        return finalDate;
    }

    return (
        <>
            <div>
                {(reportType == "Monthly Balance Tab" || reportType == "Trip Profit & Loss Report" || reportType == "Truck Monthly Profit & Loss" || reportType == "Truck Income Report" || reportType == "Truck Monthly Profit and Loss Report" || reportType == "Party Income Report" || reportType == "Profit Loss Report" || reportType == "Profit and Loss Report" || fromPartyIncomeReport) &&
                    <Button
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        variant="outlined"
                        size="small"
                        className={classes.filterButton}
                        onClick={handleDateFilterClickOpen}
                    >

                        <span>{selectedMonth ? selectedMonth : ""}</span>

                        <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
                    </Button>
                }
            </div>

            {reportType == "Trip Book" &&
                <div>
                    <Button
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        variant="outlined"
                        size="small"
                        onClick={handleDateFilterClickOpen}
                        className={classes.filterButtonTrip}
                    >

                        <span>{selectedMonth ? selectedMonth : ""}</span>

                        <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
                    </Button>
                </div>
            }
            {reportType == "expenses" &&
                <Box display={'flex'} alignItems={'center'}>
                    <span className={classes.selected}>{selectedMonth ? selectedMonth : ""}</span>
                    <Button
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        variant="outlined"
                        size="small"
                        onClick={handleDateFilterClickOpen}
                        className={classes.filterButtonExpenses}
                    >
                        <SelectionDropDown className={classes.selectionIcon} />
                    </Button>
                </Box>
            }

            {open &&

                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1000 }}>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper className={classes.paper1}>
                                <ClickAwayListener onClickAway={handleClose}><MenuList autoFocusItem={open} id="menu-list-grow">

                                    {/* For Single Party Page Monthly Balance Report. */}
                                    {(reportType == "Monthly Balance Tab" || reportType == "Trip Book") && user.pnlMonths && user.pnlMonths.map((value, index) => (
                                        <div className={classes.wV1} key={index}>
                                            <div className={classes.wV1} >
                                                <MenuItem key={value} className={classes.menuItemV1} onClick={() => handleItemClick(value)}>{value.replace(/-/g, " ")}</MenuItem>
                                                <Divider light />
                                            </div>
                                        </div>
                                    ))
                                    }

                                    {(reportType == "Trip Profit & Loss Report" || reportType == "Truck Monthly Profit & Loss") && vehicle.tripPNLMonths && vehicle.tripPNLMonths.months && vehicle.tripPNLMonths.months.map((value, index) => (
                                        <div className={classes.wV1} key={index}>

                                            <div className={classes.wV1} >
                                                <MenuItem key={value} className={classes.menuItemV1} onClick={() => handleItemClick(value)}>{value.replace(/-/g, " ")}</MenuItem>
                                                <Divider light />
                                            </div>

                                        </div>
                                    ))
                                    }


                                    {(reportType == "Truck Income Report" || reportType == "Truck Monthly Profit and Loss Report" || reportType == "Party Income Report" || reportType == "Profit Loss Report" || reportType == "Profit and Loss Report"  || fromPartyIncomeReport) && user.pnlMonths && user.pnlMonths.map((value, index) => (
                                        <div className={classes.wV1} key={index}>
                                            <div className={classes.wV1} >
                                                <MenuItem key={value} className={classes.menuItemV1} onClick={() => handleItemClick(value)}>{formatDateTruckIncome(value)}</MenuItem>
                                                <Divider light />
                                            </div>
                                        </div>
                                    ))
                                    }
                                    {reportType === "expenses" && MONTHS && MONTHS.map((value, index) => (
                                        <div className={classes.wV1} key={index}>
                                            <div className={classes.wV1} >
                                                <MenuItem key={value} className={classes.menuItemV1} onClick={() => handleItemClick(value)}>{value.display}</MenuItem>
                                                <Divider light />
                                            </div>
                                        </div>
                                    ))
                                    }
                                </MenuList></ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            }
        </>
    );
}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FilterComponent);